import { type YDatabase } from '@databases/collab/y-database';
import { type IntlShape } from 'react-intl-next';

import { cardToGalleryLayout } from './migrations/card-to-gallery-layout';
import { filterId } from './migrations/filter-id';
import { groupFieldIdToGroupingSettings } from './migrations/group-field-id-to-grouping-settings';
import { initialDoc } from './migrations/initial-doc';
import { initialView } from './migrations/initial-view';
import { newNumberFormat } from './migrations/new-number-format';
import { parentPageContentId } from './migrations/parent-page-content-id';
import { sortToMultiSort } from './migrations/sort-to-multi-sort';
import { transformAttachments } from './migrations/transform-attachments';
import { transformViews } from './migrations/transform-views';

interface Migration {
  readonly version: number;

  apply(
    documentId: string,
    database: YDatabase,
    intlShape: IntlShape
  ): void | Promise<void>;
}

export class MigrationManager {
  private static readonly migrations: Migration[] = [
    initialDoc,
    parentPageContentId,
    initialView,
    transformViews,
    transformAttachments,
    filterId,
    sortToMultiSort,
    newNumberFormat,
    cardToGalleryLayout,
    groupFieldIdToGroupingSettings
  ];

  constructor(
    private readonly documentId: string,
    private readonly database: YDatabase,
    private readonly intlShape: IntlShape,
    private readonly remoteVersion: number
  ) {}

  async runPending() {
    for (const pendingMigration of this.pendingMigrations) {
      await pendingMigration.apply(this.documentId, this.database, this.intlShape);
    }
  }

  static getClientDocVersion(): number {
    const latestMigration = MigrationManager.migrations.reduce((prev, current) =>
      prev.version > current.version ? prev : current
    );
    return latestMigration.version;
  }

  private get pendingMigrations() {
    return MigrationManager.migrations.filter(
      (migration) => migration.version > this.remoteVersion
    );
  }
}
